
export const getJWTToken = async () => {
    let tokenInfo = sessionStorage.getItem("TokenInfo")
      ? JSON.parse(sessionStorage.getItem("TokenInfo"))
      : null;
    
    if (tokenInfo === "undefined") {
      return null;
    }
    /*const expireTime = new Date(tokenInfo.expires_in).getTime();
    let currentTime = new Date().toUTCString();
    currentTime = currentTime.replace(" GMT", "");
    currentTime = new Date(currentTime).getTime(); */
    const expireTime = tokenInfo.expires_in;
    const currentTime = new Date().getTime();
    
    if (currentTime < expireTime) {
        return {
            id_token: tokenInfo.id_token,
            access_token: tokenInfo.access_token,
            username: tokenInfo.username,
            email: tokenInfo.email
        };
    } else {
      sessionStorage.removeItem("TokenInfo");
      return null;
    }
};

